import { IlustrationWrapper } from '../styled'

export const People = () => (
  <IlustrationWrapper>
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="256" height="227" viewBox="0 0 256 227">
      <defs>
        <linearGradient id="b" x1="50%" x2="50%" y1="100%" y2="0%">
          <stop offset="0%" stopColor="#50E3C2"></stop>
          <stop offset="100%" stopColor="#6BFFDE"></stop>
        </linearGradient>
        <ellipse id="a" cx="61" cy="61.5" rx="61" ry="61.5"></ellipse>
        <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="98.442%">
          <stop offset="0%" stopColor="#B2693F"></stop>
          <stop offset="96.956%" stopColor="#AD6F46"></stop>
        </linearGradient>
        <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#002709"></stop>
          <stop offset="100%" stopColor="#031700"></stop>
        </linearGradient>
        <linearGradient id="f" x1="50%" x2="50%" y1="100%" y2="2.889%">
          <stop offset="0%" stopColor="#9C3"></stop>
          <stop offset="100%" stopColor="#95C733"></stop>
        </linearGradient>
        <linearGradient id="g" x1="50%" x2="50%" y1="0%" y2="97.634%">
          <stop offset="0%" stopColor="#130027"></stop>
          <stop offset="100%" stopColor="#060108"></stop>
        </linearGradient>
        <ellipse id="h" cx="61" cy="61.5" rx="61" ry="61.5"></ellipse>
        <linearGradient id="i" x1="50%" x2="50%" y1="0%" y2="97.837%">
          <stop offset="0%" stopColor="#29232B"></stop>
          <stop offset="100%" stopColor="#363537"></stop>
        </linearGradient>
        <linearGradient id="k" x1="50%" x2="50%" y1="0%" y2="98.675%">
          <stop offset="0%" stopColor="#363537"></stop>
          <stop offset="100%" stopColor="#363537"></stop>
        </linearGradient>
        <linearGradient id="l" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#F7B186"></stop>
          <stop offset="100%" stopColor="#FFC299"></stop>
        </linearGradient>
        <linearGradient id="m" x1="50%" x2="50%" y1="100%" y2="0%">
          <stop offset="0%" stopColor="#FCF2EB"></stop>
          <stop offset="100%" stopColor="#FFF9F5"></stop>
        </linearGradient>
        <linearGradient id="n" x1="50%" x2="50%" y1="0%" y2="98.058%">
          <stop offset="0%" stopColor="#363537"></stop>
          <stop offset="100%" stopColor="#363537"></stop>
        </linearGradient>
        <ellipse id="o" cx="61" cy="61.5" rx="61" ry="61.5"></ellipse>
        <linearGradient id="q" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#E6864E"></stop>
          <stop offset="100%" stopColor="#EB965E"></stop>
        </linearGradient>
        <path
          id="r"
          d="M79.3 14.35c1.967 4.407 3.458 13.29 4.473 26.65H0c1.015-13.36 2.506-22.243 4.473-26.65C7.058 8.56 24.09 1.911 29.082 0c2.883 3.25 7.012 5.33 12.805 5.33 5.792 0 9.921-2.08 12.804-5.33C59.683 1.911 76.715 8.56 79.3 14.35z"
        ></path>
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-971 -76)">
          <g transform="translate(846)">
            <g transform="translate(24 77)">
              <g transform="translate(102)">
                <ellipse
                  cx="148"
                  cy="121.5"
                  stroke="#ECECEC"
                  strokeWidth="2"
                  rx="82"
                  ry="82.5"
                ></ellipse>
                <ellipse
                  cx="106.5"
                  cy="121"
                  stroke="#ECECEC"
                  strokeWidth="2"
                  rx="67.5"
                  ry="68"
                ></ellipse>
                <circle
                  cx="194.5"
                  cy="210.5"
                  r="6.5"
                  stroke="#F2F2F2"
                  strokeWidth="3"
                ></circle>
                <g transform="translate(46 17)">
                  <g>
                    <mask id="c" fill="#fff">
                      <use xlinkHref="#a"></use>
                    </mask>
                    <use fill="url(#b)" xlinkHref="#a"></use>
                    <g mask="url(#c)">
                      <g transform="translate(12.2 12.71)">
                        <path
                          fill="url(#d)"
                          fillRule="evenodd"
                          d="M61.813 59.45v9.02c0 .595-4.337 1.794-13.013 3.597-8.676-1.549-13.013-2.748-13.013-3.597 0-2.41.049-14.513 0-25.753-5.829-7.616-5.829-12.377-1.22-17.297 3.072-3.28 15.543-5.74 37.413-7.38 1.64 15.91 2.59 26.024 2.847 30.34.155 2.604 1.83 11.07-4.677 11.07h-8.337z"
                        ></path>
                        <path
                          fill="#F5C6A6"
                          fillRule="evenodd"
                          d="M61.813 58.68v4.936c-8.716-1.565-13.731-4.867-15.046-9.906 3.795 2.597 8.675 4.237 14.64 4.92.136.016.271.032.406.05z"
                          style={{ mixBlendMode: 'multiply' }}
                        ></path>
                        <path
                          fill="url(#e)"
                          fillRule="nonzero"
                          d="M91.5 87.046c2.581 5.291 4.614 14.038 6.1 26.24H0c1.486-12.204 3.52-20.95 6.1-26.24 1.715-3.515 10.526-8.654 26.433-15.42l32.534-.002c15.91 6.774 24.722 11.915 26.433 15.422z"
                        ></path>
                        <path
                          fill="url(#f)"
                          fillRule="evenodd"
                          d="M51.647 74.21l2.033 37.72h-9.76l2.033-37.72c1.266-1.367 2.214-2.05 2.847-2.05s1.581.683 2.847 2.05z"
                        ></path>
                        <path
                          fill="#789F2A"
                          fillRule="evenodd"
                          d="M52.058 81.843l-6.318-3.68.213-3.953c1.266-1.367 2.214-2.05 2.847-2.05s1.581.683 2.847 2.05l.411 7.633z"
                        ></path>
                        <path
                          fill="#FFF"
                          fillRule="evenodd"
                          d="M48.8 72.1564502L44.7333333 79.54 32.1266667 71.75 35.7866667 66.42 48.8 71.2666378 61.8133333 66.42 65.4733333 71.75 52.8666667 79.54z"
                        ></path>
                        <path
                          fill="url(#g)"
                          fillRule="nonzero"
                          d="M41.082 30.424c-1.294-1.12-2.865-1.873-5.086-.71-5.266 2.759-1.771 13.391 4.122 13.184 2.032-.072 1.1 4.014-4.331 6.712 0-4.305-6.507-14.965-7.074-24.67-6.55-2.459-4.923-12.293-.426-12.293-.72-9.017 13.6-13.672 19.144-8.5C53.07-2.664 67.303.82 68.163 6.73c9.787-5.267 16.22 9.875 7.056 15.751-3.77 2.418-12.592 3.34-25.326 3.34-6.11 0-2.597 14.42-.686 19.074 2.44 5.945 16.063 6.765 20.333 6.15 3.334-.48 5.083-1.845 5.287-2.665 3.05 8.2-.814 13.12-6.914 13.12-10.37 0-20.74-3.075-22.366-10.66-1.295-6.037-1.224-15.778-4.465-20.416z"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
                <g transform="translate(46 101)">
                  <g>
                    <mask id="j" fill="#fff">
                      <use xlinkHref="#h"></use>
                    </mask>
                    <use fill="#5FCE6C" fillRule="nonzero" xlinkHref="#h"></use>
                    <path
                      fill="url(#i)"
                      fillRule="nonzero"
                      d="M89.654 20.379c1.627-7.175-6.086-12.68-14.03-8.901-18.706 8.901-7.851 22.226-1.141 20.791 6.71-1.435 13.545-4.715 15.171-11.89z"
                      mask="url(#j)"
                      transform="matrix(-1 0 0 1 155.073 0)"
                    ></path>
                    <path
                      fill="url(#k)"
                      fillRule="nonzero"
                      d="M69.947 65.6c-8.737 4.231-10.011 4.005-29.28-11.89C11.59 29.725 39.04 7.79 68.523 19.475 100.447 33.62 89.751 56.008 69.947 65.6z"
                      mask="url(#j)"
                    ></path>
                    <path
                      fill="url(#l)"
                      d="M70.76 82.41c-2.982 6.56-6.778 9.84-9.76 9.84s-6.778-3.28-9.76-9.84v-8.2c-.885.026-1.63.026-2.237 0-9.511-.411-12.69-15.837-11.197-31.268 1.093-11.3 10.587 4.208 26.04-6.657-.61 11.89 4.474 10.66 6.71 9.225 10.167-4.715 10.37 14.555.322 13.062.004.205-.035 8.15-.118 23.838z"
                      mask="url(#j)"
                    ></path>
                    <path
                      fill="#ECA17F"
                      fillRule="nonzero"
                      d="M51.24 74.21c3.66-.273 8.22-2.337 13.678-6.191-1.673 5.807-6.232 9.238-13.678 10.291v-4.1z"
                      mask="url(#j)"
                    ></path>
                    <path
                      fill="url(#m)"
                      d="M47.878 84.795c.409-2.847 1.093-4.393 2.052-4.637 1.439-.366 9.848-.41 9.856 1.23 0 .301.289 3.528 1.248 3.528.959 0 1.205-3.227 1.207-3.528.007-1.64 8.368-1.576 9.855-1.23.992.231 1.674 1.779 2.046 4.642 14.64 6.95 22.73 11.909 24.271 14.876 1.988 3.826 3.48 12.71 4.474 26.65H19.113c.994-13.94 2.486-22.824 4.474-26.65 1.54-2.966 9.637-7.926 24.29-14.881z"
                      mask="url(#j)"
                    ></path>
                    <path
                      fill="#664F4D"
                      d="M61 111.11c.898 0 1.627.734 1.627 1.64 0 .906-.729 1.64-1.627 1.64a1.633 1.633 0 01-1.627-1.64c0-.906.729-1.64 1.627-1.64zm0-8.2c.898 0 1.627.734 1.627 1.64 0 .906-.729 1.64-1.627 1.64a1.633 1.633 0 01-1.627-1.64c0-.906.729-1.64 1.627-1.64zm0-8.2c.898 0 1.627.734 1.627 1.64 0 .906-.729 1.64-1.627 1.64a1.633 1.633 0 01-1.627-1.64c0-.906.729-1.64 1.627-1.64z"
                      mask="url(#j)"
                    ></path>
                    <path
                      fill="url(#n)"
                      fillRule="nonzero"
                      d="M71.327 32.565c6.507 16.4 2.847 24.395-2.237 34.03-3.389 6.424-2.982 12.642 1.22 18.655-4.88-3.143-7.32-8.2-7.32-15.17 0-10.455 7.32-17.015 1.22-25.625-6.1-8.61.61-28.29 7.117-11.89z"
                      mask="url(#j)"
                      transform="matrix(-1 0 0 1 136.634 0)"
                    ></path>
                  </g>
                </g>
                <g transform="translate(126 58)">
                  <g>
                    <mask id="p" fill="#fff">
                      <use xlinkHref="#o"></use>
                    </mask>
                    <use fill="#F1E84E" fillRule="nonzero" xlinkHref="#o"></use>
                    <path
                      fill="#110023"
                      d="M26.313 51.577C-1.892 26.57 26.29 5.587 55.33 18.306c3.107 1.36 12.012-3.34 19.914 2.217 5.098 3.585 2.974 6.18 4.912 8.916 1.938 2.737 9.774 2.855 11.247 9.838.873 4.136-2.09 8.334-1.822 11.433.268 3.1 3.139 5.986 3.137 10.066-.002 7.252-5.826 13.133-13.01 13.135-.284 7.043-6.015 12.682-13.048 12.684-2.245 0-7.92-.198-12.694-3.335-11.961-7.861-8.962-15.11-27.653-31.683z"
                      mask="url(#p)"
                      transform="scale(-1 1) rotate(-2 0 3125.989)"
                    ></path>
                    <path
                      fill="url(#q)"
                      d="M50.833 79.54c0-3.69-.124-21.89-.118-22.198-10.048 1.493-9.845-17.777.322-13.062 2.236 1.435 8.54 0 7.93-11.89 10.98 11.89 23.727-1.978 24.82 9.322 1.493 15.431-.008 31.58-9.52 31.58-.91 0-1.944-.104-3.1-.312v6.56c0 2.733 2.44 4.783 7.32 6.15-8.43 8.007-14.394 11.99-17.894 11.947-3.5-.043-9.193-4.026-17.08-11.947 4.88-1.367 7.32-3.417 7.32-6.15z"
                      mask="url(#p)"
                    ></path>
                    <path
                      fill="#DB6F3D"
                      fillRule="nonzero"
                      d="M57.038 72.733c5.548-1.01 10.312-2.91 14.292-5.696-2.541 5.683-7.349 8.947-14.423 9.794l.13-4.098z"
                      mask="url(#p)"
                      transform="scale(-1 1) rotate(-2 0 3745.266)"
                    ></path>
                    <g mask="url(#p)">
                      <g transform="translate(19.113 83.64)">
                        <mask id="s" fill="#fff">
                          <use xlinkHref="#r"></use>
                        </mask>
                        <use
                          fill="#D93E53"
                          fillRule="nonzero"
                          stroke="none"
                          xlinkHref="#r"
                        ></use>
                        <path
                          fill="#A3D9FB"
                          fillRule="nonzero"
                          stroke="none"
                          d="M1.22 34.44a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.267 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.266 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.267 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.267 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.266 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm-73.2-8.2a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.267 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.267 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.266 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.267 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm-73.2-8.2a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.267 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.266 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.267 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.267 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.266 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm-73.2-8.2a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.267 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.267 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.266 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.267 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm-73.2-8.2A2.45 2.45 0 013.66 4.1a2.45 2.45 0 01-2.44 2.46A2.45 2.45 0 01-1.22 4.1a2.45 2.45 0 012.44-2.46zm16.267 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm48.8 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46zm16.266 0a2.45 2.45 0 012.44 2.46 2.45 2.45 0 01-2.44 2.46 2.45 2.45 0 01-2.44-2.46 2.45 2.45 0 012.44-2.46z"
                          mask="url(#s)"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
                <ellipse
                  cx="193.5"
                  cy="17"
                  stroke="#ECECEC"
                  strokeWidth="2"
                  rx="16.5"
                  ry="17"
                ></ellipse>
                <circle
                  cx="12"
                  cy="116"
                  r="12"
                  stroke="#ECECEC"
                  strokeWidth="2"
                ></circle>
                <path
                  fill="#D8D8D8"
                  d="M192.5 9c.592 0 1.071.48 1.071 1.071v5.357h5.358a1.071 1.071 0 110 2.143h-5.358v5.358a1.071 1.071 0 01-2.142 0l-.001-5.358h-5.357a1.071 1.071 0 110-2.142l5.357-.001v-5.357c0-.591.48-1.071 1.072-1.071z"
                  opacity="0.498"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </IlustrationWrapper>
)

export const Time = () => (
  <IlustrationWrapper>
    <svg xmlns="http://www.w3.org/2000/svg" width="250" height="225" viewBox="0 0 250 225">
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-981 -89)">
          <g transform="translate(846)">
            <g transform="translate(136 90)">
              <g>
                <circle cx="124.5" cy="79.5" r="79.5" stroke="#ECECEC" strokeWidth="2"></circle>
                <circle cx="79.5" cy="143.5" r="79.5" stroke="#ECECEC" strokeWidth="2"></circle>
                <circle cx="168.5" cy="143.5" r="79.5" stroke="#ECECEC" strokeWidth="2"></circle>
                <circle cx="124.5" cy="119.5" r="79.5" fill="#00263A"></circle>
                <path fill="#ECEFF1" fillRule="nonzero" d="M141.336 127.582a18.94 18.94 0 016.286 14.08v13.255a2.475 2.475 0 01-2.478 2.47h-41.288a2.475 2.475 0 01-2.478-2.47v-13.254a18.936 18.936 0 016.286-14.081l5.592-5.018a4.074 4.074 0 001.368-3.064c0-1.183-.486-2.27-1.368-3.06l-5.592-5.022a18.94 18.94 0 01-6.286-14.08V84.082a2.475 2.475 0 012.478-2.47h41.288a2.475 2.475 0 012.478 2.47v13.254a18.936 18.936 0 01-6.286 14.081l-5.592 5.018a4.074 4.074 0 00-1.368 3.064c0 1.183.486 2.27 1.368 3.06l5.592 5.022z"></path>
                <path fill="#FFC107" fillRule="nonzero" d="M110.946 154.163v-14.64c0-2.435.97-4.72 2.731-6.442l9.027-8.822a2.552 2.552 0 011.796-.728c.65 0 1.301.241 1.796.728l9.027 8.822c1.762 1.722 2.731 4.007 2.731 6.441v14.641h-27.108z"></path>
                <path fill="#607D8B" fillRule="nonzero" d="M150.722 152.551H98.278c-1.813 0-3.278 1.445-3.278 3.225S96.465 159 98.278 159h52.444c1.813 0 3.278-1.445 3.278-3.224 0-1.78-1.465-3.225-3.278-3.225zM150.722 80H98.278C96.465 80 95 81.445 95 83.224c0 1.78 1.465 3.225 3.278 3.225h52.444c1.813 0 3.278-1.445 3.278-3.225S152.535 80 150.722 80z"></path>
                <path fill="#FFC107" fillRule="nonzero" d="M134.313 105.519l-8.017 7.629a2.588 2.588 0 01-1.796.71c-.65 0-1.301-.236-1.796-.71l-8.017-7.63c-2.413-2.295-3.741-5.346-3.741-8.59 0-1.334 1.138-2.418 2.541-2.418h22.026c1.403 0 2.541 1.084 2.541 2.419 0 3.243-1.328 6.294-3.74 8.59z"></path>
                <path fill="#ECECEC" d="M15.622 31.014h.1a1.5 1.5 0 011.495 1.495l.022 6.3a1.5 1.5 0 01-1.505 1.505h-.1a1.5 1.5 0 01-1.495-1.495l-.022-6.3a1.5 1.5 0 011.505-1.505z" transform="rotate(45 15.678 35.664)"></path>
                <path fill="#ECECEC" d="M4.81 31.014h.1a1.5 1.5 0 011.495 1.495l.022 6.3a1.5 1.5 0 01-1.505 1.505h-.1a1.5 1.5 0 01-1.495-1.495l-.022-6.3a1.5 1.5 0 011.505-1.505z" transform="scale(1 -1) rotate(45 90.966 0)"></path>
                <path fill="#ECECEC" d="M15.622 41.902h.1a1.5 1.5 0 011.495 1.495l.022 6.3a1.5 1.5 0 01-1.505 1.506h-.1a1.5 1.5 0 01-1.495-1.495l-.022-6.3a1.5 1.5 0 011.505-1.506z" transform="scale(1 -1) rotate(45 128.066 0)"></path>
                <path fill="#ECECEC" d="M4.81 41.902h.1a1.5 1.5 0 011.495 1.495l.022 6.3a1.5 1.5 0 01-1.505 1.506h-.1a1.5 1.5 0 01-1.495-1.495l-.022-6.3a1.5 1.5 0 011.505-1.506z" transform="rotate(45 4.866 46.553)"></path>
                <path fill="#ECECEC" d="M242.622 31.014h.1a1.5 1.5 0 011.495 1.495l.022 6.3a1.5 1.5 0 01-1.505 1.505h-.1a1.5 1.5 0 01-1.495-1.495l-.022-6.3a1.5 1.5 0 011.505-1.505z" transform="rotate(45 242.678 35.664)"></path>
                <path fill="#ECECEC" d="M231.81 31.014h.1a1.5 1.5 0 011.495 1.495l.022 6.3a1.5 1.5 0 01-1.505 1.505h-.1a1.5 1.5 0 01-1.495-1.495l-.022-6.3a1.5 1.5 0 011.505-1.505z" transform="scale(1 -1) rotate(45 317.966 0)"></path>
                <path fill="#ECECEC" d="M242.622 41.902h.1a1.5 1.5 0 011.495 1.495l.022 6.3a1.5 1.5 0 01-1.505 1.506h-.1a1.5 1.5 0 01-1.495-1.495l-.022-6.3a1.5 1.5 0 011.505-1.506z" transform="scale(1 -1) rotate(45 355.066 0)"></path>
                <path fill="#ECECEC" d="M231.81 41.902h.1a1.5 1.5 0 011.495 1.495l.022 6.3a1.5 1.5 0 01-1.505 1.506h-.1a1.5 1.5 0 01-1.495-1.495l-.022-6.3a1.5 1.5 0 011.505-1.506z" transform="rotate(45 231.866 46.553)"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </IlustrationWrapper>
)

export const Envelope = () => (
  <IlustrationWrapper>
    <svg xmlns="http://www.w3.org/2000/svg" width="249" height="160" viewBox="0 0 249 160">
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-984 -90)">
          <g transform="translate(849)">
            <g transform="translate(135 90)">
              <g>
                <rect width="52" height="5" x="27" y="121" fill="#ECECEC" rx="2"></rect>
                <rect width="30" height="5" x="0" y="107" fill="#ECECEC" rx="2"></rect>
                <rect width="9" height="5" x="13" y="121" fill="#ECECEC" rx="2"></rect>
                <rect width="52" height="5" x="197" y="19" fill="#ECECEC" rx="2"></rect>
                <rect width="30" height="5" x="190" y="34" fill="#ECECEC" rx="2"></rect>
                <ellipse cx="127" cy="80" fill="#397615" fillRule="nonzero" rx="81" ry="80"></ellipse>
                <path fill="#FFF" fillRule="nonzero" d="M84.8200092 54.4295432L84.8200092 105.407898 109.180911 79.8156471z"></path>
                <path fill="#FFF" fillRule="nonzero" d="M170.895197 54.4295432L170.895197 105.407898 146.534295 79.9187207z"></path>
                <path fill="#FFF" fillRule="nonzero" d="M86.444 52.836h82.827L136.72 85.805c-2.317 2.346-5.517 3.672-8.861 3.672-3.345 0-6.545-1.326-8.861-3.672L86.444 52.836z"></path>
                <path fill="#FFF" fillRule="nonzero" d="M138.597 87.107c-2.793 2.83-6.707 4.454-10.74 4.454-4.031 0-7.945-1.623-10.738-4.454l-5.521-5.595L86.444 107h82.827l-25.153-25.49-5.521 5.596z"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </IlustrationWrapper>
)
